import { SetStateAction, useEffect, useState } from 'react'
import { TitleH1 } from '../../../Components/CustomUi/titleH1'
import ViewPage from '../../../Components/ViewPage'
import { ContainerAtribuicao } from './styles'
import { useLogic } from '../../../context/useLogic'
import { Form } from 'antd'
import { useHistory } from 'react-router'
import { getPropriedade } from '../../../services/Propriedades'
import { AxiosResponse } from 'axios'
import { getEquipe, TypesEquipe } from '../../../services/Equipe'
import { parseArrayNumeros } from '../../../utils'
import { ItensPerUserLogged } from '../../../services/login/permissaoUsuarioLoado'
import { uniq, uniqBy } from 'lodash'
import FormularioAtribuicao from './components/cadastro'
import { TabelaAtribuicaoCargos } from './components/tabela'
import { useGetCargos } from '../../../services/cadastroCargo/GET'
import { usePostCargoPropriedade } from '../../../services/atribuicaoCargoPropriedade/POST'
import { useDeleteAtribuicao } from '../../../services/atribuicaoCargoPropriedade/DELETE'

const AtribuicaoCargos: React.FC = () => {
  const [permissions, setPermissions] = useState<ItensPerUserLogged>()

  //TABELA
  const [propriedades, setPropriedades] = useState([])
  const [pagination, setPagination] = useState<number>(15)
  const [page, setPage] = useState<number>(1)
  const [confirmar_exclusao, setConfirmar_exclusao] = useState<boolean>(false)
  const [id_item_atual, setId_item_atual] = useState<number>(null)
  const [nome_item_atual, setNome_item_atual] = useState<string>('')
  const [fake_loading, setFake_loading] = useState<boolean>(false)
  const [propriedade_selecionada, setPropriedade_selecionada] = useState<string>('')
  const [propriedade_selecionada_id, setPropriedade_selecionada_id] = useState<number>(0)
  const [buscarTabela, setBuscarTabela] = useState<string>('')
  const [listagem_cargos, setListagem_cargos] = useState([])
  const [equipes_cargos, setEquipes_cargos] = useState([])
  const [removidos, setRemovidos] = useState([])
  const [removidos_propriedade, setRemovidos_propriedade] = useState([])
  const [total, setTotal] = useState<number>(0)
  const [loading_table, setLoading_table] = useState<boolean>(false)
  

  //FORMULARIO
  const [openGaveta, setOpenGaveta] = useState<boolean>(false)
  const [dataEquipe, setDataEquipe] = useState([])
  const [equipe_selecionado, setEquipe_selecionado] = useState<string>('')
  const [equipe_selecionado_id, setEquipe_selecionado_id] = useState<number>(0)
  const [selecionados_add, setSelecionados_add] = useState<number[]>([])
  const [marcar_todos_add, setMarcar_todos_add] = useState<boolean>(false)
  const [selecionados_add_propriedade, setSelecionados_add_propriedade] = useState<
    { descr: string; id: number; key?: number }[]
  >([])
  const [marcar_todos_add_propriedade, setMarcar_todos_add_propriedade] = useState<boolean>(false)
  const [editar, setEditar] = useState<boolean>(false)
  const [loadingTable, setLoadingTable] = useState<boolean>(false)
  const [adicionados, setAdicionados] = useState([])
  const [adicionadosTabela, setAdicionadosTabela] = useState([])
  const [marcarTodos, setMarcarTodos] = useState<boolean>(false)

  //API
  const { data_cargos, carregando_cargos, refetch_data_cargos } = useGetCargos(-1)
  const { mutate_salvar_atribuicao, carregando_salvar_atribuicao } = usePostCargoPropriedade()
  const { mudate_deletar_atribuicao, carregando_deletar_atribuicao } = useDeleteAtribuicao()

  const listarPropriedades = async () => {
    const response = await getPropriedade('')
    const dadosFiltrados = response.data.itens.filter((item) => item?.status === 1)
    setPropriedades(dadosFiltrados)
  }

  async function listarEquipe() {
    const response: AxiosResponse<TypesEquipe> = await getEquipe({
      pagination: -1,
      status: 1,
    })

    setDataEquipe(response.data.itens)
  }
  async function listarEquipeAtribuicao() {
    setLoading_table(true)
    const response: AxiosResponse<TypesEquipe> = await getEquipe({
      pagination: pagination,
      page: page,
      nome: buscarTabela,
      status: 1,
      embed: 'cargos',
    })

    const equipes = response.data.itens.map((item) => {
      return {
        cod: item?.cod_func,
        usuario: item?.usuario_nome,
        cargos: item?.cargos,
      }
    })
    setEquipes_cargos(equipes)
    setTimeout(() => {
      setLoading_table(false)
    }, 500)
  }

  function filtragemPorPropriedade() {
    const filtrado = equipes_cargos.filter((item) =>
      item.cargos.some((cargo) => cargo.cod_propriedade === propriedade_selecionada_id)
    )
    setTotal(filtrado?.length)
    setListagem_cargos(filtrado)
  }

  function editarEquipeCargo(cod) {
    const filtrado = listagem_cargos.filter((item) => item.cod === cod)
    const filtradoCargoPorPropriedade = filtrado[0]?.cargos
      .filter((item) => item?.cod_propriedade === propriedade_selecionada_id)
      .map((item) => item?.cod_cargo)
    const cods_cargos = filtrado[0]?.cargos.map((item) => item?.cod_cargo)
    setRemovidos(cods_cargos)
    const filtradoPorPropriedade = filtrado[0]?.cargos
      .filter((item) => item?.cod_propriedade === propriedade_selecionada_id)
      .map((item) => {
        return {
          descr: item?.propriedade_nome,
          id: item?.cod_propriedade,
          key: item?.cod_propriedade,
        }
      })
    const cods_propriedades = filtrado[0]?.cargos.map((item) => {
      return {
        descr: item?.propriedade_nome,
        id: item?.cod_propriedade,
        key: item?.cod_propriedade,
      }
    })

    setRemovidos_propriedade(filtrado[0]?.cargos.map((item) => item?.cod_propriedade))
    setSelecionados_add(propriedade_selecionada_id > 0 ? filtradoCargoPorPropriedade : uniq(cods_cargos))
    setSelecionados_add_propriedade(
      propriedade_selecionada_id > 0
        ? uniqBy(filtradoPorPropriedade, (item) => JSON.stringify(item))
        : uniqBy(cods_propriedades, (item) => JSON.stringify(item))
    )

    setEquipe_selecionado(filtrado[0]?.usuario)
    setEquipe_selecionado_id(cod)
    setEditar(true)
    setOpenGaveta(true)
  }

  function fecharGaveta() {
    setOpenGaveta(false)
    setEquipe_selecionado('')
    setEquipe_selecionado_id(null)
    setSelecionados_add([])
    setMarcar_todos_add(false)
    setEditar(false)
    setAdicionados([])
    setAdicionadosTabela([])
    setPropriedade_selecionada_id(0)
    setPropriedade_selecionada('')
    listarEquipeAtribuicao()
  }

  // function testeCadastro() {
  //   let contador2 = 0
  //   const cargosRemovidos = removidos.filter(
  //     (item) => !parseArrayNumeros(selecionados_add).includes(item)
  //   )
  //   //@ts-ignore

  //   setAdicionadosTabela((prev) => {
  //     const novos = selecionados_add_propriedade.map((prop) => ({
  //       id: contador2++,
  //       nome_usuario: equipe_selecionado,
  //       cod_propriedade: prop?.id,
  //       cargos: [...selecionados_add],
  //     }))

  //     return [...prev, ...novos]
  //   })

  //   setAdicionados((prev) => [...prev, ...novos])
  //   setEquipe_selecionado('')
  //   setEquipe_selecionado_id(0)
  //   setSelecionados_add_propriedade([])
  // }

  function remover(cod, cod_propriedade, cargos) {
    const itensRemovidos = adicionados
      .filter((item) => item?.cod_propriedade === cod_propriedade)
      .filter((obj) => cargos.includes(obj.cargo))
    setAdicionados((prev) => prev.filter((obj) => obj.id !== cod))
    setAdicionadosTabela((prev) => prev.filter((obj) => obj.id !== cod))

    setRemovidos(itensRemovidos.map(({ id, ...resto }) => resto))
  }

  function salvarAlteracao(type: 'add' | 'remover') {
    let contador = 0
    let remover = []
    const cargosRemovidos = removidos.filter(
      (item) => !parseArrayNumeros(selecionados_add).includes(item)
    )
    const cods_propriedade_selecionadas = selecionados_add_propriedade.map((item) => item?.id)

    const propriedadesRemovidas = removidos_propriedade.filter(
      (item) => !parseArrayNumeros(cods_propriedade_selecionadas).includes(item)
    )

    // let adicionar = []

    // adicionar.push(
    //   //@ts-ignore
    //   ...[...new Set(selecionados_add_propriedade)].flatMap((cod_propriedade) =>
    //     [...new Set(selecionados_add)].map((cod_cargo) => ({
    //       cod_propriedade: cod_propriedade,
    //       cod_cargo,
    //     }))
    //   )
    // )

    remover.push(
      //@ts-ignore
      ...[...new Set(selecionados_add_propriedade)].flatMap((cod_propriedade) =>
        [...new Set(cargosRemovidos)].map((cod_cargo) => ({
          cod_propriedade: cod_propriedade?.id,
          cod_cargo,
        }))
      )
    )
    //@ts-ignore
    const removerPropriedade = propriedadesRemovidas.flatMap((cod_propriedade) =>
      selecionados_add.map((cod_cargo) => ({
        cod_propriedade,
        cod_cargo,
      }))
    )

    //@ts-ignore
    const novos = selecionados_add_propriedade.flatMap((prop) =>
      selecionados_add.map((cargo) => ({
        id: contador++,
        cod_propriedade: prop.id,
        cod_cargo: cargo,
      }))
    )

    mutate_salvar_atribuicao({
      editar: editar,
      cod_usuario: equipe_selecionado_id,
      cargos_propriedade: novos.map(({ id, ...resto }) => resto),
      cargos_propriedade_remover: remover.length > 0 ? remover : removerPropriedade,
      refetchGerenciar: () => {
        refetch_data_cargos()
        listarEquipeAtribuicao()
        fecharGaveta()
      },
      limpar: type === 'add' ? () => setSelecionados_add([]) : () => setRemovidos([]),
    })
  }

  function deletarAtribuicao(cod) {
    setFake_loading(true)
    mudate_deletar_atribuicao({
      cod_atribuicao: cod,
      refetch_deletar: () => {
        refetch_data_cargos()
        listarEquipeAtribuicao()
        setFake_loading(false)
      },
    })
  }

  function listaDisponiveis() {
    return data_cargos?.itens
  }

  useEffect(() => {
    listarPropriedades()
    listarEquipe()
    refetch_data_cargos()
  }, [])

  useEffect(() => {
    listarEquipeAtribuicao()
  }, [pagination, page])

  useEffect(() => {
    if (propriedade_selecionada_id !== null) {
      filtragemPorPropriedade()
    } else {
      setLoading_table(true)
      setListagem_cargos([])
      setTotal(0)
      setTimeout(() => {
      setLoading_table(false)
    }, 500)
    }
  }, [propriedade_selecionada_id])

  // useEffect(() => {
  //   if (buscarTabela.length > 2) {
  //     setTimeout(() => {
  //       listarEquipeAtribuicao()
  //     }, 700)
  //   }
  //   if (buscarTabela === '') {
  //     listarEquipeAtribuicao()
  //   }
  // }, [buscarTabela])

  useEffect(() => {
    if (marcar_todos_add_propriedade) {
      const todasPropriedade = propriedades.map((item) => {
        return {
        descr: item?.nome,
        id: item?.cod,
        key: item?.cod,
      }
      })
      setSelecionados_add_propriedade(todasPropriedade)
    }else{
      setSelecionados_add_propriedade([])
    }
  }, [marcar_todos_add_propriedade])

  return (
    <ContainerAtribuicao>
      <ViewPage
        title='Cargos na propriedade'
        btnClick={null}
        newHide
        onPermission={setPermissions}
        rotina={105}
        hiddeTitle
        cardBodyStyle={{ padding: 15 }}
        content={
          <FormularioAtribuicao
            openGaveta={openGaveta}
            fecharGaveta={fecharGaveta}
            editar={editar}
            loadingSalvar={carregando_salvar_atribuicao}
            cadastrar={salvarAlteracao}
            listar_equipe={dataEquipe}
            listar_cargos={data_cargos?.itens}
            equipe_selecionado={equipe_selecionado}
            setEquipe_selecionado={setEquipe_selecionado}
            setEquipe_selecionado_id={setEquipe_selecionado_id}
            selecionados_add={selecionados_add}
            setSelecionados_add={setSelecionados_add}
            marcar_todos_add={marcar_todos_add}
            setMarcar_todos_add={setMarcar_todos_add}
            selecionados_add_propriedade={selecionados_add_propriedade}
            setMarcar_todos_add_propriedade={setMarcar_todos_add_propriedade}
            marcar_todos_add_propriedade={marcar_todos_add_propriedade}
            setSelecionados_add_propriedade={setSelecionados_add_propriedade}
            setRemovidos_propriedade={setRemovidos_propriedade}
            listaDisponiveis={listaDisponiveis}
            listaDisponiveisPropriedade={propriedades}
            salvarAlteracao={salvarAlteracao}
            setRemovidos={setRemovidos}
            propriedade_selecionada_id={propriedade_selecionada_id}
            cargos_adicionados={adicionadosTabela}
            loadingTable={loadingTable}
            remover={remover}
            permissions={permissions}
          />
        }
      >
        <TitleH1>Cargos na propriedade</TitleH1>
        <TabelaAtribuicaoCargos
          loading={loading_table}
          setPagination={setPagination}
          page={page}
          setPage={setPage}
          total={total}
          listar_atribuicao={listagem_cargos}
          propriedades={propriedades}
          setOpen={setOpenGaveta}
          permissao={permissions}
          editarCadastro={editarEquipeCargo}
          deletar={deletarAtribuicao}
          confirmar_exclusao={confirmar_exclusao}
          setConfirmar_exclusao={setConfirmar_exclusao}
          id_item_atual={id_item_atual}
          setId_item_atual={setId_item_atual}
          nome_item_atual={nome_item_atual}
          setNome_item_atual={setNome_item_atual}
          fake_loading={fake_loading}
          setFake_loading={setFake_loading}
          buscarTabela={buscarTabela}
          setBuscarTabela={setBuscarTabela}
          propriedade_selecionada={propriedade_selecionada}
          setPropriedade_selecionada={setPropriedade_selecionada}
          propriedade_selecionada_id={propriedade_selecionada_id}
          setIdPropriedade_selecionada={setPropriedade_selecionada_id}
        />
      </ViewPage>
    </ContainerAtribuicao>
  )
}

export default AtribuicaoCargos